module.exports = __webpack_public_path__ + "static/radek-milion-ada7bc8132aa427e2d813c4a2185da25.jpg";